// Search
export const SEARCH_PAGE_VIEW = 'searchPageView';
export const SEARCH_PAGE_CLICKTHROUGH = 'searchPageClickthrough';
export const SEARCH_SORT_CLICK = 'sortSearchClick';
export const SEARCH_FACET_CLICK = 'facetClick';
export const TOP_BANNER_AD_CLICK = 'advertisementClick';
export const TOP_BANNER_AD_IMPRESSION = 'advertisementImpressionWrapper';
export const SEARCH_PILL_GROUP_TOGGLE = 'facetAttributeDropdownClick';
export const SEARCH_SWATCH_INTERACTION = 'swatchInteraction';
export const SEARCH_SWATCH_IMPRESSION_WRAPPER = 'swatchImpressionWrapper';
export const SEARCH_PRODUCT_INTERACTION = 'searchProductInteraction';
export const SEARCH_AUTO_COMPLETE_IMPRESSION = 'searchAutoCompleteImpression';
export const SEARCH_AUTO_COMPLETE_INTERACTION = 'searchAutoCompleteInteraction';
export const NAVIGATION_FACET_SEARCH = 'navigationFacetSearch';
export const SEARCH_ZERO_STATE_IMPRESSION = 'searchZeroStateImpression';
export const SEARCH_ZERO_STATE_INTERACTION = 'searchZeroStateInteraction';
export const SEARCH_CLEAR_FILTERS = 'searchClearFilters';

// Header
export const TOP_LEVEL_NAV_CLICK = 'topLevelNavigationClick';
export const EXPLICIT_SEARCH = 'explicitSearch';
export const NAVIGATION_CLICK = 'navigationClick';

// Landing
export const HOME_PAGE_VIEW = 'homePageView';
export const LANDING_PAGE_VIEW = 'landingPageView';
export const BROADCAST_EMAIL_SIGNUP = 'broadcastEmailSignup';
export const BRAND_EMAIL_SIGNUP = 'brandEmailSignUp';

// PDP
export const PRODUCT_PAGE_VIEW = 'productPageView';
export const SIZING_IMPRESSION = 'sizingImpression';
export const PRODUCT_ACCORDION_EVENT = 'productAccordionEvent';
export const PRODUCT_SOCIAL_ICON_EVENT = 'productSocialIconEvent';
export const PRODUCT_SHARE_ICON_TOOLTIP_EVENT = 'productShareIconTooltipEvent';
export const PRODUCT_GENDER_EVENT = 'productGenderEvent';
export const PRODUCT_COUNTRY_UNIT_EVENT = 'productCountryUnitEvent';
export const PRODUCT_EMPTY_SIZE_OPTIONS_EVENT = 'productEmptySizeOptionsEvent';
export const PRODUCT_IMAGE_IMPRESSION = 'productImageImpression';
export const PRODUCT_IMAGE_THUMBNAIL_EVENT = 'productImageThumbnailEvent';
export const PRODUCT_FEATURED_ZOOM_EVENT = 'productFeaturedZoomEvent';
export const PRODUCT_VIEW_SIZE_CHART = 'productViewSizeChart';
export const PRODUCT_ZOOM_IN_EVENT = 'productZoomInEvent';
export const PRODUCT_ZOOM_OUT_EVENT = 'productZoomOutEvent';
export const OUT_OF_STOCK_MODAL_VIEW = 'outOfStockModalView';
export const RECO_DRAWER_BUTTON_CLICK = 'recoDrawerButtonClick';
export const PRODUCT_NO_STYLE_SIZES = 'productNoStyleSizes';
export const BADGE_CATEGORY_CLICK = 'badgeCategoryClick';
export const ACCORDION_IMPRESSION = 'accordionImpression';
export const PRODUCT_IMAGE_SWIPE_EVENT = 'productImageSwipeEvent';
export const PRODUCT_LOWEST_RECENT_PRICE = 'productLowestRecentPrice';
export const COLOR_TWISTER_TOGGLE_CLICK = 'colorTwisterClick';

// Cart
export const CART_ADD = 'addToCart';
export const CART_PAGE_VIEW = 'cartPageView';
export const PROCEED_TO_CHECKOUT = 'proceedToCheckout';

// Account
export const ADD_TO_COLLECTIONS = 'addToCollections';
export const SUBSCRIPTIONS_PAGE_CHANGE = 'subscriptionsPageChange';
export const SUBSCRIPTIONS_PAGE_VIEW = 'subscriptionsPageView';
export const UNSUBSCRIBE_FROM_ALL_CLICK = 'unsubscribeFromAllClick';
export const SAVE_CHANGES_CLICK = 'saveChangesClick';

// Checkout
export const PAYMENT_SECTION = 'PAYMENT_SECTION';
export const SHIPPING_SECTTION = 'SHIPPING_SECTION';
export const BILLING_ADDRESS_SECTION = 'BILLING_ADDRESS_SECTION';

// Media Source
export const UNKNOWN_MEDIA_SOURCE_TYPE = 'UNKNOWN_MEDIA_SOURCE_TYPE';

// Pixel
export const PIXEL_EVENT = 'pixel_event';

// Collections
export const COLLECTION_PRODUCT_CLICK_THROUGH = 'collection_product_click_through';

// Brand Shop the Look
export const BRAND_SHOP_THE_LOOK_SEARCH_IMPRESSION = 'brand_shop_the_look_search_impression';
export const BRAND_SHOP_THE_LOOK_IMPRESSION = 'brand_shop_the_look_impression';
export const BRAND_SHOP_THE_LOOK_CARD_CLICK = 'brand_shop_the_look_card_click';

// Style Feed
export const STYLE_FEED_PAGE_VIEW = 'style_feed_page_view';
export const STYLE_FEED_CARD_CLICK = 'style_feed_card_click';

// Balder
export const EXCHANGE_INITIATE_PAGE = 'EXCHANGE_INITIATE_PAGE';
export const ORDER_DETAIL_PAGE = 'ORDER_DETAIL_PAGE';

// Outfit Recos
export const OUTFIT_RECO_CARD_VIEW = 'outfit_reco_card_view';
export const OUTFIT_RECO_CARD_CLICK = 'outfit_reco_card_click';
export const OUTFIT_FEEDBACK = 'outfit_feedback';

// Click to Display
export const INTERACTION_TO_COMPLETE_VIEW = 'interactionToCompleteView';
export const OUTFIT_RECO_MODAL_CAROUSEL_CLICK = 'outfit_reco_modal_carousel_click';
export const OUTFIT_RECO_MODAL_VIEW_DETAILS_CLICK = 'outfit_reco_modal_view_details_click';

// Web Vital
export const WEB_VITAL = 'web_vital';

// Prodcut Comparison Table
export const PRODUCT_COMPARISON_TABLE_VIEW = 'product_comparison_table_view';
export const PRODUCT_COMPARISON_TABLE_PRODUCT_INTERACTION = 'product_comparison_table_product_interaction';

// Launch Calendar
export const LAUNCH_CALENDAR_PAGE_VIEW = 'launch_calendar_page_view';
export const LAUNCH_CALENDAR_SECTION_CLICK = 'launch_calendar_section_click';
export const LAUNCH_CALENDAR_CARD_CLICK = 'launch_calendar_card_click';
export const LAUNCH_CALENDAR_SUBSCRIPTION_CLICK = 'launch_calendar_subscription_click';

// Returns
export const REFUND_METHOD_CLICK = 'refundMethodClick';

// Global Dual Banner
export const GLOBAL_DUAL_BANNER_CLICK = 'globalDualBannerClick';
export const GLOBAL_DUAL_BANNER_IMPRESSION = 'globalDualBannerImpression';
export const GENERIC_IMPRESSION = 'genericImpression';
